import styled from 'styled-components';
import Tag from '../../../../../components/Molecules/Tag/Tag';
import { media } from '../../../../../theme/shared/breakpoints';
export const StyledTagsContainer = styled.div `
  display: flex;
  overflow: scroll;
  width: calc(100% + 30px);
  margin: 0 -15px;
  flex-wrap: wrap;
  width: 100%;
  margin: 0;
  padding-left: 0;

  &::-webkit-scrollbar {
    display: none;
  }
`;
export const StyledTag = styled(Tag) `
  font-size: ${({ theme }) => theme.fontSizes.sizeSm3};
  margin-bottom: 10px;
  margin-right: 10px;
  transition: box-shadow 0.3s ease;

  &:hover {
    box-shadow: ${({ theme }) => theme.shadows.small};
  }
`;
export const StyledDropdownContent = styled.div `
  padding-top: 20px;
  border-top: 1px solid ${({ theme }) => theme.colorsV2.ui.border.primary};

  ${media.medium} {
    border-top: none;
  }
`;
export const StyledBoxContainer = styled.div `
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 20px;
  row-gap: 16px;

  ${media.medium} {
    grid-template-columns: repeat(4, 1fr);
  }
`;
export const StyledBox = styled.div `
  background-image: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),
    ${({ bgImage }) => `url(${bgImage})`};
  background-position: center;
  background-size: cover;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-align: center;
  padding: 0 6px;
  height: 100px;
  transition: box-shadow 0.3s ease;
  cursor: pointer;

  &:hover {
    box-shadow: ${({ theme }) => theme.shadows.small};
  }

  @media (-webkit-min-device-pixel-ratio: 2) {
    background-image: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),
      ${({ bgImage2x }) => `url(${bgImage2x})`};
  }
`;
//# sourceMappingURL=MostPopularSearches.styled.js.map